import WithLabel from './_WithLabel';
import InputText from './_InputText';
import WpEditor from '../_wp_editor';
import ImageRadio from './_ImageRadio';
import InputRadio from './_InputRadio';
import InputOptions from './_InputOptions';
import InputGroupedOptions from './_InputGroupedOptions';
import InlineCheckbox from './_InlineCheckbox';
import VerifiedEmailInput from './_VerifiedEmailInput';
import CheckboxGroup from './_InputCheckboxes';
import InputData from './InputPopover.vue';
export default {
  name: 'global_form_builder',
  components: {
    WithLabel: WithLabel,
    InputText: InputText,
    WpEditor: WpEditor,
    ImageRadio: ImageRadio,
    InputRadio: InputRadio,
    InputOptions: InputOptions,
    InlineCheckbox: InlineCheckbox,
    VerifiedEmailInput: VerifiedEmailInput,
    CheckboxGroup: CheckboxGroup,
    InputGroupedOptions: InputGroupedOptions,
    InputData: InputData
  },
  props: {
    formData: {
      type: Object,
      required: false,
      "default": function _default() {
        return {};
      }
    },
    label_position: {
      required: false,
      type: String,
      "default": function _default() {
        return 'top';
      }
    },
    fields: {
      required: true,
      type: Object
    },
    suggests: {
      required: false,
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  methods: {
    nativeSave: function nativeSave() {
      this.$emit('nativeSave', this.formData);
    },
    /**
     * Helper function for show/hide dependent elements
     & @return {Boolean}
     */
    compare: function compare(operand1, operator, operand2) {
      switch (operator) {
        case '=':
          return operand1 === operand2;
        case '!=':
          return operand1 !== operand2;
      }
    },
    /**
     * Checks if a prop is dependent on another
     * @param listItem
     * @return {boolean}
     */
    dependancyPass: function dependancyPass(listItem) {
      if (listItem.dependency) {
        var optionPaths = listItem.dependency.depends_on.split('/');
        var dependencyVal = optionPaths.reduce(function (obj, prop) {
          return obj[prop];
        }, this.formData);
        if (this.compare(listItem.dependency.value, listItem.dependency.operator, dependencyVal)) {
          return true;
        }
        return false;
      }
      return true;
    }
  }
};